export default "/static/d207c8b9efaca54a.png"